/*@ngInject*/
const ScoringRulesRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadActions = function (scoringRuleId) {
        const url = '/rest/Actions',
            config = {
                params: {
                    uri: 'com.firstbest.underwriting.scoring.ScoringRule:' + (_.isNil(scoringRuleId) ? null : scoringRuleId)
                }
            };

        return this.get(url, config);
    };

    this.getScoringRulesByParam = function (requestParams) {
        const url = '/rest/ScoringRule',
            config = {
                params: {
                    searchString: requestParams.nameSearchString,
                    folderIds: requestParams.selectedCategoryList,
                    sortBy: requestParams.key,
                    sortDirection: requestParams.sortType,
                    startIndex: requestParams.startIndex,
                    numberOfRows: requestParams.pageSize
                }
            };

        return this.get(url, config);
    };


    this.getScoringRuleById = function (scoringRuleId) {
        const url = '/rest/ScoringRule/' + scoringRuleId;
        return this.get(url);
    };

    this.saveScoringRule = function (scoringRule) {
        let url = '/rest/ScoringRule/',
            body = scoringRule,
            config = {
                params: {}
            };
        // body.formulas = null;
        if(!_.isNil(scoringRule.id)){
            url += scoringRule.id;
        }
        return this.post(url, body, config);
    };

    this.deleteScoringRule = function (scoringRuleId) {
        const url = '/rest/ScoringRule/' + scoringRuleId;
        return this.delete(url);
    };


};

angular.module('ums.configuration')
    .service('scoringRulesRepository', ScoringRulesRepository);

